'use strict';

var keys = Object.keys;

module.exports = function (object) {
	return keys(object == null ? object : Object(object));
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es5-ext/object/keys/shim.js
 ** module id = 74
 ** module chunks = 2
 **/